import React from "react";
import "../assets/css/FooterSection.css";
import book from "../assets/imgs/book2.png";

import insta from '../assets/imgs/instagram.png';
import fb from '../assets/imgs/fb.png';
import linked from '../assets/imgs/linked.png';
import yt from '../assets/imgs/Yt.png';
import twitter from '../assets/imgs/twitter.png';


const FooterSection = () => {
    return (
        <footer>

            {/* SOCIAL BAR */}

            <div className="social-bar">

                <div className="social-box"><img src={fb}></img>Like on Facebook</div>
                <div className="social-box"><img src={twitter}></img>Follow on Twitter</div>
                <div className="social-box"><img src={yt}></img>Watch on YouTube</div>
                <div className="social-box"><img src={linked}></img>Connect on LinkedIn</div>
                <div className="social-box"><img src={insta}></img>Follow on Instagram</div>

            </div>


            {/* FOOTER CONTENT */}

            <div className="footer-main">

                {/* COLUMN 1 */}

                <div className="footer-col">

                    <h3>
                        Indrajeet <span>Patil</span>
                    </h3>

                    <p>
                        Motivational Speaker, Business Psychologist,
                        Educational Counsellor and Writer helping
                        entrepreneurs, real estate professionals and
                        business owners transform their mindset,
                        leadership and decision making abilities.
                    </p>

                    <p className="copyright">
                        © 2026 Indrajeet Patil. All rights reserved.
                    </p>

                    <div className="footer-icons">
                        <span>F</span>
                        <span>T</span>
                        <span>In</span>
                    </div>

                </div>


                {/* COLUMN 2 */}

                <div className="footer-col center-col">

                    <h4>Check My Books</h4>

                    <img src={book} alt="Book" />

                    <button className="book-btn">
                        GET THE BOOKS
                    </button>

                </div>


                {/* COLUMN 3 */}

                <div className="footer-col">

                    <h4>Subscribe</h4>

                    <p>
                        Sign up to receive latest insights, seminars,
                        and leadership updates from Indrajeet Patil.
                    </p>

                    <div className="subscribe-box">

                        <input
                            type="email"
                            placeholder="Your Email Address"
                        />

                        <button>Join List</button>

                    </div>

                </div>

            </div>

        </footer>
    );
};

export default FooterSection;